const WEBHOOK_URL = 'https://us-central1-auctionringers-e6565.cloudfunctions.net/whitelabelbuddyImport';

export interface WebhookResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export const syncAuctionToRinger = async (auction: any): Promise<WebhookResponse> => {
  try {
    console.log('📤 Syncing auction to AuctionRinger:', auction.id);

    const payload = {
      action: 'auction.created',
      data: {
        id: auction.id,
        auctionHouseId: auction.auctionHouseId,
        auctionHouseName: 'Schmidt Auctions',
        title: auction.title,
        description: auction.description,
        startDate: auction.startDate.toISOString(),
        endDate: auction.endDate.toISOString(),
        location: auction.location,
        status: auction.status,
        totalLots: auction.totalLots,
        lots: auction.lots.map((lot: any) => ({
          sku: lot.sku,
          lotNumber: lot.lotNumber,
          title: lot.title,
          description: lot.description,
          startingBid: lot.startingBid,
          category: lot.category,
          images: lot.images && lot.images.length > 1 ? lot.images.slice(1) : [],
          status: lot.status,
        })),
      },
    };

    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Webhook failed:', errorText);
      return { success: false, error: errorText };
    }

    const result = await response.json();
    console.log('✅ Auction synced successfully:', result);
    return { success: true, message: result.message };

  } catch (error) {
    console.error('❌ Webhook error:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error' 
    };
  }
};